import { Component } from '@angular/core';
import { OnlineStatusService, OnlineStatusType } from 'ngx-online-status';
import { ToastrService } from 'ngx-toastr';
import { UserData } from '../data-models/user-models/user-data.model';
import { AuthenticationService } from '../services/authentication.service';
import { EmailService } from '../services/reporting/email.service';
import { CommonDataService } from '../services/storage/common-data.service';
import { UserStorageService } from '../services/storage/user-storage.service';

@Component({
    selector: 'app-dev',
    templateUrl: './dev.component.html',
    styleUrls: ['./dev.component.css'],
    standalone: false
})
export class DevComponent {

  userDetails: UserData = new UserData();
  noticeHTML: string = "insert HTML to test here";

  constructor(
    private toastr: ToastrService,
    private onlineStatusService: OnlineStatusService,
    private authenticationService: AuthenticationService,
    public commonDataService: CommonDataService,
    public emailService: EmailService
  ){

    let docsToGet: string[] = ['management_areas_list', 'species_list', 'product_types'];

    this.authenticationService.getUserDetails().then(() => {
      this.userDetails = UserStorageService.currUser;
      commonDataService.getSpecifiedDocs(this.userDetails.userEmail, docsToGet).then(() => {
        // Data has been retrieved! We can access it as shown below:
        console.log('LOGGING FROM DEV COMPONENT')
        console.log(CommonDataService.managementAreas);
        console.log(CommonDataService.speciesList);
        console.log(CommonDataService.productTypes);
      });
    });

  }

  sendTestEmail(): void {
    this.emailService.sendEmail(this.userDetails.userEmail, "S00000", "T00000");
    
  }

  updateData(): void { // perform data sync

    if (this.onlineStatusService.getStatus() === OnlineStatusType.OFFLINE) {
      this.toastr.error("Cannot sync while offline", "Error");
      return;
    }

    CommonDataService.pullCommonData().then((result: boolean) => {  // pull data from common couch
      if (!result) { // display error if data cannot be synced
        this.toastr.error("Unable to Sync Data", "Error");
        return;
      }
      // display message if data successfully synced
      this.toastr.success("Data Synced!", "Success");
    });

  }

}
